import { ThemeProvider } from "@emotion/react";
import { Box, Paper, Typography } from "@mui/material";
import Form from "../components/Form";
import Theme from "../utils/theme";
import { useSelector } from "react-redux";
import type { RootState } from "../store";
import { useMemo } from "react";

const Register = () => {
    const themeState = useSelector((state: RootState) => state.theme);
    const theme = useMemo(() => Theme(themeState.mode), [themeState.mode]);

    return (
        <ThemeProvider theme={theme}>
            <Box
                sx={{
                    minHeight: "100dvh",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "linear-gradient(to right, #f5f7fa, #c3cfe2)",
                }}
            >
                <Paper
                    elevation={3}
                    sx={{
                        width: "100%",
                        maxWidth: 420,
                        p: 5,
                        borderRadius: { xs: "none", sm: 3 },
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: 3,
                    }}
                >
                    {/* Logo and Heading */}
                    <Box sx={{ textAlign: "center" }}>
                        <Box component="img" src="/images/coocoo.png" alt="CooCoo Logo" sx={{ width: 80 }} />
                        <Typography variant="h5" fontWeight="bold">
                            Register
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            Create your account below.
                        </Typography>
                    </Box>

                    {/* Register Form */}
                    <Box sx={{ width: "100%", mb: 8 }}>
                        <Form method="register" route="/auth/register/" />
                    </Box>

                    {/* Log In Link */}
                    <Box sx={{ display: "flex", marginTop: 1 }}>
                        <Typography variant="body2" color="text.secondary" sx={{ mr: 1 }}>
                            Already have an account?
                        </Typography>
                        <Typography component="a" href="/login" variant="body2" color="text.secondary">
                            Log In
                        </Typography>
                    </Box>
                </Paper>
            </Box>
        </ThemeProvider>
    );
};

export default Register;
